/* KHAVIYAR cart drawer trust line (25 Oct 2026). Jos Poulakis rule 12 / Section Store: a trust banner and one real
   review next to the checkout button. Adds "4.7 / 5 from 76 verified reviews" and one verified quote above the
   Checkout button of the KH cart drawer (assets/kh-cart-drawer.js) every time it renders. Real Klaviyo Reviews only. */
(function () {
  'use strict';
  var RATING = '4.7', COUNT = 76;
  var Q = [
    ['The best of the best. Probably the best caviars out there.', 'Peter V.'],
    ['They arrive quickly and cold as well. I am very happy with the quality of the caviar, delicious.', 'Dana T.'],
    ['High quality Oscietra caviar. Setting a benchmark for this product.', 'Paul E.'],
    ['Excellent quality. CITES information clearly labelled, which is very important to ensure traceability.', 'Leanne K.'],
    ["Taste was amazing, we're already planning for another occasion.", 'Iain A.']
  ];
  var CSS = '.khcd__trust{margin:0 0 12px;padding:10px 12px;border:1px solid rgba(201,163,92,.45);border-left:3px solid #c9a35c;background:#faf9f7}' +
    '.khcd__trust p{margin:0}.khcd__trust-top{font-size:13px;color:#000e34}.khcd__trust-stars{color:#c9a35c;letter-spacing:2px;margin-right:4px}' +
    '.khcd__trust-q{margin-top:4px!important;font-size:13px;font-style:italic;line-height:1.4;color:rgba(0,14,52,.85)}' +
    '.khcd__trust-q span{display:block;font-style:normal;font-size:10.5px;letter-spacing:1.2px;text-transform:uppercase;color:#8a6d2f;margin-top:2px}';
  var n = Math.floor(Math.random() * Q.length), styled = false;
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function add() {
    var foot = document.querySelector('.khcd [data-khcd-foot]');
    if (!foot) return;
    var go = foot.querySelector('a.khcd__go');
    if (!go || foot.querySelector('.khcd__trust')) return;
    if (!styled) { var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st); styled = true; }
    var q = Q[n % Q.length];
    var box = document.createElement('div');
    box.className = 'khcd__trust';
    box.innerHTML = '<p class="khcd__trust-top"><span class="khcd__trust-stars" aria-hidden="true">&#9733;&#9733;&#9733;&#9733;&#9733;</span><b>' + RATING + ' / 5</b> from ' + COUNT + ' verified reviews</p>' +
      '<p class="khcd__trust-q">&ldquo;' + esc(q[0]) + '&rdquo;<span>' + esc(q[1]) + ' &middot; Verified buyer</span></p>';
    foot.insertBefore(box, go);
  }
  function watch() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function () { add(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
